export default __webpack_public_path__ + "static/media/savvi-financial-logo.e135326f.svg";